import type { QueryClient } from "@tanstack/react-query";

import { isNotebookPathname } from "@/lib/notebook/core/notebook-route-entry";

/**
 * Workspace list queries that go stale after notebook editing or navigation
 * (browser Back/bfcache from openNotebook, or SPA exit from /notebook/*).
 */
export function invalidateDashboardQueries(qc: QueryClient): void {
  void qc.invalidateQueries({ queryKey: ["scrolls"] });
  void qc.invalidateQueries({ queryKey: ["folders"] });
  void qc.invalidateQueries({ queryKey: ["home-momentum"] });
  void qc.invalidateQueries({ queryKey: ["workspace-search"] });
}

export function shouldRefreshDashboardOnHistoryRestore(pathname: string): boolean {
  return !isNotebookPathname(pathname);
}
